const NAMQ_THEME_STORAGE_KEY = 'namq-theme';

function getNamqTheme() {
  return document.documentElement.dataset.theme === 'dark'
    ? 'dark'
    : 'light';
}

function updateNamqThemeControls() {
  const theme = getNamqTheme();
  const isDark = theme === 'dark';

  document.querySelectorAll('[data-namq-theme-toggle]').forEach((button) => {
    const label = isDark
      ? 'Switch to light mode'
      : 'Switch to dark mode';

    button.setAttribute('aria-label', label);
    button.setAttribute('aria-pressed', String(isDark));

    const hiddenLabel = button.querySelector('[data-namq-theme-label]');

    if (hiddenLabel) {
      hiddenLabel.textContent = label;
    }
  });
}

function setNamqTheme(theme, persist = true) {
  const nextTheme = theme === 'dark' ? 'dark' : 'light';

  document.documentElement.dataset.theme = nextTheme;

  if (persist) {
    try {
      localStorage.setItem(NAMQ_THEME_STORAGE_KEY, nextTheme);
    } catch (error) {
      // Storage may be unavailable.
    }
  }

  updateNamqThemeControls();

  document.dispatchEvent(
    new CustomEvent('namq:theme-change', {
      detail: { theme: nextTheme },
    })
  );
}

function toggleNamqTheme() {
  setNamqTheme(getNamqTheme() === 'dark' ? 'light' : 'dark');
}

function initializeNamqThemeControls() {
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-namq-theme-toggle]');

    if (!toggle) return;

    toggleNamqTheme();
  });

  updateNamqThemeControls();

  document.documentElement.classList.add('namq-theme-ready');
}

window.NAMQTheme = {
  get: getNamqTheme,
  set: setNamqTheme,
  toggle: toggleNamqTheme,
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeNamqThemeControls,
    { once: true }
  );
} else {
  initializeNamqThemeControls();
}